import React from "react";
import { Link } from "react-router-dom";
import classes from "./MHFooter.module.css";

function MhFooter(props) {
  return (
    <footer className={props.ShowNav ? classes.ForceFooter : null}>
      <div className={classes.footer__wrapper}>
        {/* address */}

        <div className={classes.mh__address__uk}>
          <div>MATCHHAMPERS LTD. </div>
          <div></div>(registered in England & Wales, 13238757){" "}
        </div>
        <div className={classes.mh__address__jersey}>
          <div>Matchhampers (Jersey) LTD. </div>{" "}
          <div>(registered in Jersey, 156161)</div>
          <div>Registered Jersey Address: </div>
          <span>8 La Courte Piece, JE3 8DF</span>
        </div>

        <div className={classes.tradingas}>
          <div className={classes.trading}>Trading as Match Hampers</div>
        </div>
        <div className={classes.seperator} />
        <div className={classes.mh__logo}>
          <img src="/Images/Content/mh-registered-white.png"></img>
        </div>
      </div>
    </footer>
  );
}

export default MhFooter;
